import React from 'react';
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel
} from '@mui/material';

export default function Sensi({ parameters, setParameters }) {

  const set = (key, value) =>
    setParameters(prev => ({ ...prev, [key]: value }));

  const toggleRadio = (key, newValue) =>
    set(key, parameters[key] === newValue ? '' : newValue);

  const p = parameters;

  // Definizione dei sensi con pattern uniforme: [label radio, chiave radio, chiave testo, label testo]
  const sensi = [
    ['Udito normale',    'udito',    'alterazioneUdito',        'Tipo di alterazione'],
    ['Vista normale',    'vista',    'alterazioneVista',        'Tipo di alterazione'],
    ['Tatto normale',    'tatto',    'alterazioneTatto',        'Tipo di alterazione'],
    ['Gusto normale',    'gusto',    'alterazioneGusto',        'Tipo di alterazione'],
    ['Odore normale',    'odore',    'alterazioneOdore',        'Tipo di alterazione'],
    ['Vigile',           'vigile',   'alterazioneVigile',       'Tipo di alterazione'],
    ['Orientato',        'orientato','alterazioneOrientamento', 'Non orientato in'],
  ];

  return (
    <Box sx={{ width: '50ch', display: 'grid', gap: 2 }}>

      {/* TITOLO */}
      <Box sx={{ p: 3, mb: 2, border: '1px solid rgba(0,0,0,0.23)', borderRadius: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
        <Box component="h1" sx={{ m: 0, fontSize: '1.8rem', fontWeight: 'bold', color: '#1976d2' }}>
          Accertamento Infermieristico
        </Box>
        <Box component="p" sx={{ m: 0, mt: 1, fontSize: '1rem', color: 'text.secondary' }}>
          Sensi
        </Box>
      </Box>

      {/* Sensi con radio + campo condizionale */}
      {sensi.map(([label, radioKey, textKey, textLabel]) => (
        <FormControl key={radioKey} sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          <FormLabel sx={{ minWidth: 200 }}>{label}</FormLabel>
          <RadioGroup row value={p[radioKey] ?? ''}>
            <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio(radioKey, 'true')}  />} label="Sì" />
            <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio(radioKey, 'false')} />} label="No" />
          </RadioGroup>
          {p[radioKey] === 'false' && (
            <TextField
              size="small"
              label={textLabel}
              value={p[textKey] ?? ''}
              onChange={e => set(textKey, e.target.value)}
              required
              sx={{ width: 220 }}
            />
          )}
        </FormControl>
      ))}

      {/* Occhiali — solo radio, nessun campo aggiuntivo */}
      <FormControl sx={{ flexDirection: 'row', gap: 2, alignItems: 'center' }}>
        <FormLabel sx={{ minWidth: 200 }}>Utilizza occhiali</FormLabel>
        <RadioGroup row value={p.occhiali ?? ''}>
          <FormControlLabel value="true"  control={<Radio onClick={() => toggleRadio('occhiali', 'true')}  />} label="Sì" />
          <FormControlLabel value="false" control={<Radio onClick={() => toggleRadio('occhiali', 'false')} />} label="No" />
        </RadioGroup>
      </FormControl>

    </Box>
  );
}